// extracted by mini-css-extract-plugin
export var arrowSvg = "measure-section-module--arrow-svg--nz4+K";
export var closed = "measure-section-module--closed--zc5pt";
export var contentBox = "measure-section-module--contentBox--Tzvwe";
export var gridClass = "measure-section-module--gridClass--ZLO+B";
export var img = "measure-section-module--img--CgbGI";
export var imgBox = "measure-section-module--imgBox--6qQ7O";
export var moreArrow = "measure-section-module--more-arrow--MiEia";
export var open = "measure-section-module--open--b-l2Q";
export var titleBox = "measure-section-module--titleBox--+-boU";